module.exports = __webpack_public_path__ + "img/spflogo.95a6db77.png";